var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    className: "loading_svg__narratorIcon",
    preserveAspectRatio: "xMidYMid",
    style: {
      margin: "auto",
      background: "0 0",
      display: "block",
      shapeRendering: "auto"
    },
    viewBox: "0 0 100 100"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(74 50)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#fff",
    className: "loading_svg__narratorIcon"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.875s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "0.8 0.8;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.875s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 -47.355 114.326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#fff",
    fillOpacity: 0.875,
    className: "loading_svg__narratorIcon"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.75s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "0.8 0.8;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.75s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 -12 62)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#fff",
    fillOpacity: 0.75,
    className: "loading_svg__narratorIcon"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.625s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "0.8 0.8;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.625s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135 2.645 40.326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#fff",
    fillOpacity: 0.625,
    className: "loading_svg__narratorIcon"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.5s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "0.8 0.8;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.5s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 13 25)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#fff",
    fillOpacity: 0.5,
    className: "loading_svg__narratorIcon"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.375s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "0.8 0.8;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.375s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-135 23.355 9.674)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#fff",
    fillOpacity: 0.375,
    className: "loading_svg__narratorIcon"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.25s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "0.8 0.8;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.25s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 38 -12)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#fff",
    fillOpacity: 0.25,
    className: "loading_svg__narratorIcon"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.125s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "0.8 0.8;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.125s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 73.355 -64.326)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#fff",
    fillOpacity: 0.125,
    className: "loading_svg__narratorIcon"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "0s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "0.8 0.8;1 1"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  })))));
};
export default SvgLoading;